/** Nom commercial affiché dans l'interface. */
export const APP_NAME = "LeoSoft";
export const APP_NAME_SHORT = "LeoSoft";
export const APP_TAGLINE = "CRM de gestion pour conseillers";
